export default (function () {
  return getCurrentPages();
});